<div [formGroup]="form">
  @if (!isKit) {
    <div class="section-container" id="estoque">
      <div class="section-title">
        <mat-icon>inventory_2</mat-icon>
        <span>Estoque</span>
      </div>

      @if (!isVariacao && qtdLocaisPendentes > 0) {
        <app-alert-card type="warning">
          {{ tipoRastreio === 'serie' ? 'Séries' : 'Lotes' }} pendentes em {{ qtdLocaisPendentes }}
          local(is): informe os {{ tipoRastreio === 'serie' ? 'códigos de série' : 'lotes' }} até bater com o estoque atual antes de salvar.
        </app-alert-card>
      }
      <div class="row">
        <div class="col-6 col-md-3 d-flex align-items-center">
          <mat-slide-toggle class="app-toggle-compact" formControlName="isControlaEstoque"
            >Controlar Estoque</mat-slide-toggle
          >
        </div>
        <div class="col-6 col-md-3 d-flex align-items-center">
          <mat-slide-toggle class="app-toggle-compact" formControlName="isControlaLotes"
            >Controlar Lotes</mat-slide-toggle
          >
        </div>
        <div class="col-6 col-md-3 d-flex align-items-center">
          <mat-slide-toggle class="app-toggle-compact" formControlName="isControlaSeries"
            >Controlar Séries</mat-slide-toggle
          >
        </div>
      <!-- <div class="col-6 col-md-3 d-flex align-items-center">
          <mat-slide-toggle class="app-toggle-compact" formControlName="isSobEncomenda"
            >Sob Encomenda</mat-slide-toggle
          >
        </div> -->
        <div class="col-12">
          <p class="controle-rastreabilidade-hint">
            Lote rastreia grupos de unidades; série rastreia cada unidade física individualmente. Os dois modos não
            podem operar juntos.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Dias Preparação</mat-label>
            <input matInput formControlName="diasPreparacao" [currencyMask]="integerMask" />
          </mat-form-field>
        </div>
      </div>

      <!-- Grid Locais de Estoque (oculto para Com Variação: o estoque é por variação) -->
      @if (isVariacao) {
        <p class="controle-rastreabilidade-hint mt-2">
          O estoque inicial das variações é informado na seção <strong>Variações</strong>, em "Estoque por Local".
        </p>
      } @else {
      <div formArrayName="localizacoesEstoque">
        <div class="d-flex justify-content-between align-items-center mb-2 mt-4">
          <h4 class="subsection-title mb-0">Locais de Estoque</h4>
          <button mat-button type="button" (click)="addLocalEstoqueRow()">
            <mat-icon>add</mat-icon> Adicionar Local
          </button>
        </div>

        @for (item of localizacoesEstoque.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="row-wrapper local-estoque-bloco">
            <div class="row">
              <div class="col-10 col-md-11">
                <div class="row">
                  <!-- Local -->
                  <div class="col-6 col-lg-4">
                    <app-select-pesquisavel
                      [offlineList]="
                        isLocalPadrao(getControl(item, 'idLocalizacaoEstoque').value)
                          ? listaLocalizacaoEstoque
                          : listaLocalizacaoEstoqueNaoPadrao
                      "
                      [control]="getControl(item, 'idLocalizacaoEstoque')"
                      idField="idLocalizacaoEstoque"
                      nameField="nome"
                      label="Local de Estoque"
                      [disabled]="isLocalPadrao(getControl(item, 'idLocalizacaoEstoque').value)"
                      placeholder="Selecione...">
                    </app-select-pesquisavel>
                  </div>

                  <!-- Estoque Atual (editável só na inclusão) -->
                  @if (!isEditMode) {
                    <div class="col-6 col-lg-2">
                      <mat-form-field appearance="outline">
                        <mat-label>Atual</mat-label>
                        <input matInput formControlName="saldoFisico" [currencyMask]="quantidadeMask" />
                      </mat-form-field>
                    </div>
                  } @else {
                    <div class="col-2 col-lg-1">
                      <div class="fw-bold text-center stock-value">{{ (item.get('saldoFisico')?.value | abnt:'quantidade') || '—' }}</div>
                      <div class="stock-label text-center">Atual</div>
                    </div>
                    <div class="col-2 col-lg-1">
                      <div class="fw-bold text-center stock-value">{{ (item.get('saldoDisponivel')?.value | abnt:'quantidade') || '—' }}</div>
                      <div class="stock-label text-center">Disponível</div>
                    </div>
                  }

                  <!-- Estoque Mínimo -->
                  <div class="col-6 col-lg-3">
                    <mat-form-field appearance="outline">
                      <mat-label>Mínimo</mat-label>
                      <input matInput formControlName="estoqueMinimo" [currencyMask]="quantidadeMask" />
                    </mat-form-field>
                  </div>

                  <!-- Estoque Máximo -->
                  <div class="col-6 col-lg-3">
                    <mat-form-field appearance="outline">
                      <mat-label>Máximo</mat-label>
                      <input matInput formControlName="estoqueMaximo" [currencyMask]="quantidadeMask" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="col-2 col-md-1 delete-col produto-grid-delete-col">
                <!-- Delete -->
                @if (!isLocalPadrao(getControl(item, 'idLocalizacaoEstoque').value)) {
                  <button
                    mat-icon-button
                    type="button"
                    class="delete-button produto-grid-delete-button"
                    (click)="removeLocalEstoqueRow(i)"
                    matTooltip="Remover">
                    <mat-icon class="material-symbols-outlined">delete</mat-icon>
                  </button>
                }
              </div>
            </div>

            <!-- Painel inline de lote/série (balanço inicial) -->
            @if (mostrarPainelRastreio(item)) {
              <app-estoque-lote-serie-inline
                [tipo]="tipoRastreio!"
                [quantidadeAlvo]="item.get('saldoFisico')?.value || 0"
                [isFracionada]="isFracionada"
                [contexto]="nomeLocal(item)"
                [itens]="itensRastreio(item)"
                [codigosSerieEmOutrosLocais]="codigosSerieEmOutrosLocais(item)"
                (itensChange)="onItensRastreioChange(item, $event)"
                (completoChange)="onCompletoChange(item, $event)">
              </app-estoque-lote-serie-inline>
            }
          </div>
        }

        @if (localizacoesEstoque.length === 0) {
          <app-empty-state icon="inventory_2" title="Nenhum local de estoque cadastrado."
            subtitle="Adicione um local de estoque para controlar o saldo físico e disponível deste produto.">
          </app-empty-state>
        }
      </div>
      }
    </div>
  }
</div>
